/**
 * Detailový objekt pro preview událost změny výběru na DataGridu
 */
export interface SelectionChangedPreviewEventArgs {
    /**
     * Příznak, zda jde o změnu typu "vybrat vše"
     */
    selectAll?: boolean;
}
